import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { StoreShell } from "@/components/store/StoreShell";
import { OtpLogin } from "@/components/store/OtpLogin";
import { useStore } from "@/context/StoreContext";
import { api, inr, STATUS_LABEL, PAY_METHOD } from "@/lib/api";

export default function MyOrders() {
  const { customer, add, setCartOpen } = useStore();
  const [orders, setOrders] = useState(null);

  useEffect(() => { if (customer) api.get("/orders/mine").then((r) => setOrders(r.data)); }, [customer]);

  const reorder = async (o) => {
    const prods = (await api.get("/products")).data;
    let added = 0;
    o.items.forEach((it) => {
      const p = prods.find((x) => x.id === it.product_id);
      const cutOk = !it.cut || (p?.cut_options || []).some((c) => c.label === it.cut);
      if (p && p.available_qty > 0 && cutOk) { for (let k = 0; k < Math.min(it.qty, p.available_qty); k++) add(p, it.cut || ""); added++; }
    });
    toast.success(added ? `Added ${added} items at today's prices` : "None of these items are available today");
    if (added) setCartOpen(true);
  };

  return (
    <StoreShell>
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
        <h1 className="font-display text-4xl sm:text-5xl text-primary font-semibold mb-6">Your orders</h1>
        {!customer && <OtpLogin />}
        {orders?.length === 0 && <p className="text-stone-500" data-testid="no-orders">No orders yet.</p>}
        <div className="space-y-3">
          {orders?.map((o) => (
            <div key={o.id} className="bg-white rounded-2xl border border-stone-100 shadow-sm p-5 flex flex-wrap items-center gap-4" data-testid={`my-order-${o.id}`}>
              <Link to={`/orders/${o.id}`} className="flex-1 min-w-[200px]" data-testid={`my-order-link-${o.id}`}>
                <p className="font-display text-2xl text-primary font-semibold">{o.order_number}</p>
                <p className="text-sm text-stone-500">{o.delivery_date} · {o.items.length} items · {PAY_METHOD[o.payment_method]}</p>
              </Link>
              <span className="rounded-full bg-secondary/15 text-[#5c6b33] px-3 py-1 text-xs font-bold">{STATUS_LABEL[o.status]}</span>
              <span className="font-extrabold">{inr(o.amount_due)}</span>
              <button onClick={() => reorder(o)} className="flex items-center gap-1.5 h-10 px-4 rounded-full border-2 border-primary text-primary text-sm font-bold hover:bg-primary hover:text-white transition-colors" data-testid={`reorder-btn-${o.id}`}>
                <RotateCcw className="w-4 h-4" /> Order again
              </button>
            </div>
          ))}
        </div>
      </div>
    </StoreShell>
  );
}
